import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-computer",
  "use": "icon-computer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-computer\"><defs><style type=\"text/css\"></style></defs><path d=\"M820.6 740.1h-206v91.3h45.6c8.3-0.3 16.2 4 20.4 11.2 4.3 7.2 4.3 16.1 0 23.3-4.3 7.2-12.1 11.5-20.4 11.2H386.4c-12.6 0-22.8-10.2-22.8-22.8s10.2-22.8 22.8-22.8H432v-91.3H203.2c-50.4 0-91.3-40.9-91.3-91.3V238.1c0-50.4 40.9-91.2 91.3-91.2h617.5c50.4 0 91.2 40.8 91.3 91.2v410.7c-0.1 50.4-41 91.3-91.4 91.3zM157.5 603.2v45.7c0 25.2 20.4 45.6 45.6 45.6h617.5c25.2 0 45.7-20.5 45.7-45.6v-45.7H157.5z m0 0\" p-id=\"4816\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/computer.svg
// module id = i/3Z
// module chunks = 1